import { cr, ck, interact, URLS } from "fire-wind-water";
import * as sbaseData from "../common/sbase";
import { settingData } from "../common/settingData";
import service from "../service/form";
import URL from "../assets/conf/setting.json";
import { isInWechatAuth, initJsSdk, agentType } from "/stempcore/src/sbase";
import { forkJoin } from "rxjs";
export default {
  data() {
    return {
      formData: [],
      formInfo: {},
      seminarInfo: {},
      isSubmitting: false,
      member: {},
      subSeminarInfo: {},
      signPointInfo: {},
      preview: sbaseData.preview,
      linkEnd: false,
      tenantId: "",
      rulesInfo: [],
      rulesJump: 0,
      isTrackClosed: false, // 推广链接是否已关闭
      isTrackClosedMessage: false, //是否显示截止时间
    };
  },

  created() {
    sbaseData.init();
    if (!sbaseData.isSetting) {
      window.$sk.loading.show();
    }
    window.$sk.template.module(this);
  },
  computed: {
    changeData() {
      const { user, linkEnd } = this;
      return {
        user,
        linkEnd,
      };
    },
    hideLoad() {
      const { extras, formData, linkEnd } = this;
      return {
        extras,
        formData,
        linkEnd,
      };
    },
  },
  watch: {
    changeData: {
      handler: function (n) {
        if (n.linkEnd && n.user.status) {
          console.log("都监听完了");
          this.platformVSurl();
          this.afterGetData();
        }
      },
    },
    hideLoad: {
      handler: function (n) {
        if (Object.keys(n.extras).length && n.formData.length && n.linkEnd) {
          window.$sk.loading.hide();
        }
      },
    },
  },
  methods: {
    skUserInit() {
      console.log("获取用户本地信息");
    },
    checkTrackStatus() {
      var checkParams = {
        tenantId: this.tenantId,
      };
      if (sbaseData.trackId) {
        checkParams.track_id = sbaseData.trackId;
      }
      if (sbaseData.tc) {
        checkParams.tc = sbaseData.tc;
        checkParams.moduleId = window.$sk.template.get().common.moduleId;
        checkParams.moduleObjectId = sbaseData.seminarId;
      }
      service.checkTrackStatus(checkParams).subscribe((data) => {
        if (data.result == 0) {
          if (data.content && data.content.status == 1) {
            this.customformGet();
          } else {
            this.isTrackClosed = true;
            //this.showTrackClosedMessage();
          }
        } else {
          console.warn("检查推广链接状态失败:", data.desc);
          this.customformGet();
        }
      });
    },
    showTrackClosedMessage() {
      window.$sk.loading.hide();
      window.$sk.alert("报名已截止！", {
        okValue: "确定",
        ok: () => {
          if (sbaseData.returnUrl) {
            window.$sk.goto(sbaseData.returnUrl);
          }
        },
      });
    },
    skUserEnd() {
      const info = window.$sk.template.get();
      console.log("获取用户信息结束", info);
      this.schemaId = info.common.schemaId;
      this.instanceId = info.common.instanceId;
      this.tenantId = info.common.tenantId;
      this.user = info.user;

      if (this.getEventInfo) {
        this.getEventInfo();
      }
      if (!sbaseData.isSetting) {
        if (sbaseData.trackId || sbaseData.tc) {
          this.checkTrackStatus();
        }
        this.customformGet();
      } else {
        this.formInfo = settingData;
        this.formData = settingData.items;
        this.initConfig();
      }
    },
    getSubList() {
      /* 获取分会场 */
      service
        .getSubList({
          instanceId: sbaseData.instanceId,
          customFormId: sbaseData.customFormId,
        })
        .then((data) => {
          if (data.content) {
            this.subSeminarInfo = data.content;
            if (
              this.subSeminarInfo.subSeminars &&
              this.subSeminarInfo.subSeminars.length
            ) {
              let isRequired = this.subSeminarInfo.isRequired;
              this.subSeminarInfo.subSeminars.filter((d) => {
                d.optionId = d.id;
                d.optionValue = d.name;
                d.required = isRequired;
              });

              if (this.subSeminarInfo.isOpen == 1) {
                const hasSubSeminarField = (this.formInfo.items || []).some(
                  (item) => item.subSeminar === true
                );
                if (!hasSubSeminarField) {
                  this.formInfo.items.push({
                    subSeminar: true,
                    displayName:
                      this.subSeminarInfo.subtemplatename || "分会场",
                    displayType: this.subSeminarInfo.isMulti == 1 ? "5" : "3",
                    listOptions: this.subSeminarInfo.subSeminars,
                    required: parseInt(isRequired),
                    errorMessage: "请选择分会场",
                    isShow: true,
                    isOldShow: true,
                  });
                }
              }
            }
          }
        });
    },
    getSignInPoint() {
      //获取签到点数据
      const params = {
        instanceId: this.instanceId,
        tenantId: this.tenantId,
        isAll: 1,
        needLimit: 1,
        type: "bylist",
      };
      service.getSignInPoint(params).then((data) => {
        if (data.result == "0") {
          this.signPointInfo = data.content.items;
          //替换签到点名字
          this.setSignPointName(this.signPointInfo);
        } else {
          window.$sk.alert("获取签到点数据失败");
        }
      });
    },
    setSignPointName(signPointInfo) {
      this.formInfo.items.forEach((d) => {
        // 处理签到点
        if (d.listOptionType == "SIGNINGPOINT") {
          d.signPoint = true;
          //给字段加一个flag 选项是否全部超限
          let isExceedLimitAll = false;
          //把超限状态相加如果等于选项数则全部超限
          let ExceedLimitStr = 0;
          d.listOptions.forEach((option, idy) => {
            if (d.displayType == "6" || d.displayType == "4") {
              if (idy === 0) {
                //下拉形式 第一个是默认的选项“已选择” 跳出循环
                return;
              }
            }
            signPointInfo.forEach((item) => {
              if (item.id == option.optionValue) {
                //设置签到点ID
                option.optionId = item.id;
                //设置签到名字
                option.optionValue = item.name;
                //设置启用状态 isExceedLimit:1 为超限 0为正常
                option.disabled = item.isExceedLimit == 1;

                // option.isDisabled(true);

                //超限状态 相加
                ExceedLimitStr += item.isExceedLimit;
                // ExceedLimitStr += 1;
              }
            });
          });

          let pointsNum = 0;
          if (d.displayType == "6" || d.displayType == "4") {
            pointsNum = d.listOptions.length - 1; //-1是因为smarketJS 个加了请选择
          } else {
            pointsNum = d.listOptions.length;
          }
          //如果字段内的签到点全部超限则设置该字段为非必填
          if (ExceedLimitStr >= pointsNum) {
            //
            isExceedLimitAll = true;
            //如果全部超限，必选改为选填
            d.required = 0;
          }
          //将是否全部超限的状态添加到字段
          d.isExceedLimitAll = isExceedLimitAll;
        }
      });
    },
    customformGet() {
      forkJoin({
        formData: service.getCustomform({
          customFormId: sbaseData.customFormId,
          tenantId: this.tenantId,
          linkId: sbaseData.linkId,
          globalUserId: this.user.globalUserId,
          type: this.platform,
          isReturnVerifyStatus: 1,
          ver: "v2.0.1",
        }),
        ruleData: service.getCustomFormRules({
          customFormId: sbaseData.customFormId,
          tenantId: this.tenantId,
        }),
      }).subscribe((data) => {
        if (data.ruleData.result == 0) {
          this.rulesInfo = data.ruleData.content.items;
        }
        if (data.formData.result == 0) {
          this.formInfo = data.formData.content;
          this.formInfo.items.forEach((m) => {
            m.required = parseInt(m.required, 10);
          });
          this.member =
            ck.cookie("smarketMember_" + this.formInfo.schemaId) || {};
          this.initConfig();
          this.setTitle(this.formInfo);
          this.init();
          this.handleList(this.formInfo);
          this.handleRules();
        } else {
          window.$sk.alert(data.formData.desc);
        }
      });
    },
    init() {
      this.getSubList();
      this.getSignInPoint();
      if (!sbaseData.preview || this.formInfo.identity == 3) {
        window.$sk.template.update({
          type: "link",
          data: {
            identity: this.formInfo.identity,
            weChatId: isInWechatAuth(this.tenantId)
              ? this.formInfo.attachWXAccount || sbaseData.weChatId
              : "",
            enableWxFollow: this.formInfo.enableWxFollow,
            weChatIdForSubscribe:
              this.formInfo.attachWXAccount || sbaseData.weChatId,
            skObjectType: "customForm",
            skObjectId: sbaseData.customFormId,
            meetingInstanceId:
              this.formInfo.identity == 4
                ? this.formInfo.meetingInstanceId
                : this.instanceId,
            meetingType: this.formInfo.moduleType,
            skIsNotLink: 0,
            memberFormId: this.formInfo.registerFormId,
          },
        });
      } else {
        service
          .checkRegistration({
            customFormId: sbaseData.customFormId,
            tenantId: this.tenantId,
            instanceId:
              this.formInfo.identity == 4
                ? this.formInfo.meetingInstanceId
                : this.formInfo.instanceId,
            session: this.member.session,
            sess: this.member.session,
            openId: this.user.openId,
          })
          .subscribe((data) => {
            if (data.result == 0) {
              this.skUserChange({
                status: data.content,
                formData: data.content.formData,
              });
              this.linkEnd = true;
            }
          });
      }
    },
    handleRules() {
      if (this.$refs.formRef) {
        this.$refs.formRef.initData();
      }
    },
    dicValueConvert(m) {
      if (!m.listOptionType) {
        return "";
      }
      if (m.listOptionType == "CUSTOM") {
        return m.value.toString();
      }
      if (m.listOptionType == "DICT") {
        const targetField = this.formData.find(
          (a) => a.fieldName == m.fieldName
        );
        if (!targetField) {
          return "";
        }
        return this.getDictValue(targetField.dictInfo, m.value);
      }
      return "";
    },
    getDictValue(dictInfo, values) {
      if (!values || !values.length) {
        return "";
      }
      const firstLevel = dictInfo.find((d) => d.name == values[0]);
      if (!firstLevel) {
        return "";
      }
      if (values.length == 1) {
        return firstLevel.paramId;
      }
      let currentLevel = firstLevel;
      let currentChildren = [];
      for (let i = 1; i < values.length; i++) {
        for (let key in currentLevel.child) {
          currentChildren = currentLevel.child[key];
          break;
        }
        const matchedItem = currentChildren.find(
          (item) => item.name == values[i]
        );
        if (!matchedItem) {
          return "";
        }
        if (i == values.length - 1) {
          return matchedItem.paramId;
        }
        currentLevel = matchedItem;
      }
      return "";
    },
    handleList(info) {
      const res = info?.items || [];
      const needHideFields = [];
      if (this.rulesInfo.length > 0) {
        this.rulesInfo.forEach((r) => {
          r.rules.forEach((item) => {
            if (item.rulesJump == 3) {
              needHideFields.push(item.rulesGoto);
            }
          });
        });
      }
      cr.each(res, (m, index) => {
        m.required = Number(m.required);
        if (this.rulesInfo.length > 0) {
          this.applyRulesToField(m, index, needHideFields);
        } else {
          m.isShow = true;
        }
      });
      return res;
    },
    applyRulesToField(field, index, needHideFields) {
      const ruleModel = this.rulesInfo.find(
        (r) => r.rulesCode == field.fieldName
      );
      const shouldHide = needHideFields.some((r) => field.fieldName == r);
      field.sortBy = index;
      if (
        ruleModel &&
        [1, 2, 3].includes(field.fieldLevel) &&
        Array.isArray(field.value) &&
        field.value.length > 0
      ) {
        field.ruleValue = this.dicValueConvert(field);
      }
      if (ruleModel) {
        field.rulesInfo = {
          rulesType: ruleModel.rulesType,
          rules: ruleModel.rules,
        };
      }
      field.isShow = !shouldHide;
      field.isOldShow = field.isShow;
    },
    skUserChange(data) {
      console.log("用户信息发生改变", data, this.user);
      if (data) {
        this.user.status = data.status;
        this.user.formData = data.formData;
      }
    },
    skLinkEnd() {
      console.log("跳转逻辑判断完毕");
      this.linkEnd = true;
    },
    platformVSurl() {
      const isMobile = interact.isMobile ? "wap" : "pc";
      let linkUrl = {
        pc: this.formInfo.shortUrl.pc.longUrl,
        wap: this.formInfo.shortUrl.wap.longUrl,
      };
      const shortUrl = this.formInfo.shortUrl;
      let longUrl, return_url, returnUrl;

      if (sbaseData.tc) {
        return_url =
          URLS.getURL("return_url", linkUrl.wap) ||
          URLS.getHash("return_url", linkUrl.wap);
        if (return_url) {
          return_url = URLS.updateParam("tc", sbaseData.tc, return_url);
        }
        linkUrl.wap = URLS.updateParam("return_url", return_url, linkUrl.wap);
        linkUrl.pc = URLS.updateParam("tc", sbaseData.tc, linkUrl.pc);
      }
      if (this.platform != isMobile) {
        if (sbaseData.markCode) {
          //裂变
          longUrl = shortUrl[isMobile].longUrl;
          returnUrl =
            URLS.getURL("return_url", longUrl) ||
            URLS.getHash("return_url", longUrl);
          if (returnUrl) {
            let idx = longUrl.indexOf("return_url=");
            return_url = longUrl.substring(idx + 11);
            longUrl = longUrl.replace(return_url, returnUrl);
          }
          window.$sk.goto(longUrl + "&markCode=" + sbaseData.markCode);
        } else {
          window.$sk.goto(linkUrl[isMobile]);
        }
      }
    },

    afterGetData() {
      console.log("this.user====", this.user);

      // 互动记录
      this.interactiveView();
      console.log("我要开始自己的逻辑了", this.user);
      if (
        this.user.status.signupStatus !== "notAllow" ||
        this.user.status.signupStatus !== "notallow"
      ) {
        service
          .lookup({
            customFormId: sbaseData.customFormId,
            tenantId: this.tenantId,
            instanceId:
              this.formInfo.identity == 4
                ? this.formInfo.meetingInstanceId
                : this.formInfo.instanceId,
            session: this.member.session,
            sess: this.member.session,
            openId: this.user.openId,
          })
          .subscribe(
            (data) => {
              if (data.result == 0) {
                // 处理回填
                if (data.content) {
                  cr.each(data.content, (d) => {
                    cr.each(this.formInfo.items, (m) => {
                      if (m.fieldName == d.key) {
                        m.value = d.value;
                        if (
                          m.fieldName == "mobile" &&
                          m.isCallingCodeOpen == 1
                        ) {
                          m.callingCodeLookupCountry = d.callingCode;
                          m.callingCodeLookupPhone = d.areaCode;
                        }
                      }
                    });
                  });
                }
                this.formData = cr.extend([], this.formInfo.items); //获取数据

                // 处理回填
                if (this.user.formData && this.user.formData.length) {
                  cr.each(this.user.formData, (d) => {
                    cr.each(this.formData, (m) => {
                      if (m.fieldName == d.fieldName) {
                        m.value = d.value;
                      }
                    });
                  });
                }
                // 检查表单状态
                this.statusToView();

                //this.commonWebinar();
              } else {
                this.formData = cr.extend([], this.formInfo.items); //获取数据
                window.$sk.alert(data.desc);
              }

              this.asyncError();
            },
            () => {
              //if (typeof callback === 'function') {
              //  callback(contactInfo, {result: -1, desc: '数据加载失败'});
              //}
            }
          );
      } else {
        this.formData = cr.extend([], this.formInfo.items); //获取数据
        // 处理回填
        if (this.user.formData && this.user.formData.length) {
          cr.each(this.user.formData, (d) => {
            cr.each(this.formData, (m) => {
              if (m.fieldName == d.fieldName) {
                m.value = d.value;
              }
            });
          });
        }

        this.asyncError();
        this.jumpLink();
      }
    },
    asyncError() {
      // 校验
      console.log("formData====", this.formData, this.$store.state.extras);
      this.$nextTick(() => {
        cr.each(this.formData, (m) => {
          if (
            (this.formInfo.moduleType == 2 || this.formInfo.moduleType == 3) &&
            m.isLogin == 1 &&
            m.result
          ) {
            console.log("mobile====", m);
            m.result.setAsyncError({
              key: "norepeat",
              message: `${m.displayName}${
                m.moduleId == 2 || m.moduleId == 3 ? "已报名" : "已存在"
              }`,
              validator: () => {
                return new Promise((resolve) => {
                  if (this.isSubmitting) {
                    resolve(true);
                    return;
                  }
                  service
                    .checkRepeatable({
                      customFormId: sbaseData.customFormId,
                      fieldId: m.fieldName,
                      fieldValue: m.result.value,
                      ver: "v2.0.1",
                      globalUserId: ck.cookie("globalUserId"),
                      tenantId: this.tenantId,
                    })
                    .subscribe((result) => {
                      resolve(result.content.result);
                    });
                });
              },
            });
          }
        });
      });
    },

    statusToView() {
      // 从哪里进入表单
      //this.entryPoint();
      const formInfo = this.formInfo;
      const userStatusInfo = this.user.status;

      //var self = this;
      // 报名成功直接跳转成功页
      if (
        userStatusInfo.signupStatus === "successfully" ||
        userStatusInfo.contactSignupStatus === "successfully"
      ) {
        this.jumpLink(userStatusInfo);
      }
      // 允许报名并且有注册信息，回绑字段
      else if (userStatusInfo.signupStatus === "allow") {
        if (this.isTrackClosed) {
          this.isTrackClosedMessage = true;
        }
        //允许报名 而且是线下会 并且是全部用户参与而且没有报过名表单开始了那么跳转到verify 页面 （身份验证页面）
        if (
          formInfo.moduleType == 3 &&
          formInfo.identity == 1 &&
          formInfo.status == 1 &&
          (userStatusInfo.formData == false ||
            userStatusInfo.formData.length == 0) && //注册身份
          (sbaseData.urlForm == undefined || sbaseData.urlForm != "verify") &&
          formInfo.isAuthentication == "1"
        ) {
          const type =
            this.$router.currentRoute.path &&
            this.$router.currentRoute.path.indexOf("New") > -1
              ? "New"
              : "";
          this.$router.push({
            path: `${this.platform}${type}_verify`,
            query: {
              returnUrl: sbaseData.returnUrl,
              markCode: sbaseData.markCode,
            },
          });
          return;
        }

        // 浏览表单记录互动行为
        this.interactiveBrowse();
        // 初始化微信分享
        if (agentType() == "weChat") {
          this.initWeChatShare();
        } else if (agentType() == "wxWork") {
          initJsSdk(this.tenantId, () => {
            this.initWxWorkShare();
          });
        }
      }
      // 不允许报名（包括未通过审核、活动已结束）
      else if (userStatusInfo.signupStatus.toLowerCase() === "notallow") {
        // 活动已结束
        if (userStatusInfo.instanceStatus == "completed") {
          this.formInfo.status = 2;
        } else {
          if (sbaseData.returnUrl) {
            window.$sk.goto(sbaseData.returnUrl);
          } else {
            let query = {
              needVerify:
                userStatusInfo.statusCode == "4"
                  ? 1
                  : formInfo.customFormIsNeedVerify,
              isRefuse: 1,
            };
            const str =
              window.location.href.toLocaleLowerCase().indexOf("new") > 0
                ? "New"
                : "";
            this.$router.push({
              path: `${this.platform}${str}_success`,
              query: query,
            });
          }
        }
      } else {
        // 浏览表单记录互动行为
        this.interactiveBrowse();
        // 初始化微信分享
        if (agentType() == "weChat") {
          this.initWeChatShare();
        } else if (agentType() == "wxWork") {
          initJsSdk(this.tenantId, () => {
            this.initWxWorkShare();
          });
        }
      }
    },
    interactiveView() {
      if (!sbaseData.preview) {
        service.view({
          customFormId: sbaseData.customFormId,
          linkId: sbaseData.linkId,
          trackingCode: sbaseData.tc,
          globalUserId: ck.cookie("globalUserId"),
          openId: this.user.openId,
          memberId: this.member.memberId,
          url: location.href,
          referenceUrl: document.referrer,
          weChatId: this.user.weChatId,
          sess: this.member.session,
        });
      }
    },
    interactiveBrowse() {
      service.browse({
        openId:
          this.user.openId ||
          ck.cookie("openId" + this.formInfo.attachWXAccount) ||
          "",
        sess: this.member.session || "",
        tenantId: this.formInfo.tenantId,
        customFormId: sbaseData.customFormId,
        markCode: sbaseData.markCode,
        marketingSess: ck.cookie("marketingSess"),
      });
    },

    formIsValid() {
      let count = 0;
      let verifyFail = false;
      this.formData.map((field) => {
        const val = field.value;
        if (!val && field.isShow) {
          return;
        }
        if (cr.isArray(val)) {
          if (val.length > 0) {
            count++;
          }
        } else if (typeof val === "string") {
          if (val) {
            count++;
          }
        } else if ("fieldName" in val) {
          if (val.value && (val.value.length || val.value.mapId)) {
            count++;
          }
          if (
            val.fieldName === "mobile" &&
            parseInt(field.required, 10) === 1 &&
            parseInt(field.isSendSms, 10) === 1 &&
            !val.checkCode &&
            field.isShow
          ) {
            val.VerifyFail = true;
          }
        }
        if (val.VerifyFail && field.isShow) {
          verifyFail = true;
        }
      });

      // 定位到错误位置
      let anchor = this.$el.querySelector(".err");
      if (anchor) {
        document.documentElement.scrollTop = anchor.offsetTop;
        document.body.scrollTop = anchor.offsetTop;
      }

      if (count === 0) {
        window.$sk.alert("请填写表单内容后提交");
        return false;
      } else if (verifyFail) {
        return false;
      }
      return true;
    },
    // 已报名 去会场
    togoVerify() {
      if (sbaseData.isSetting) {
        return;
      }
      this.$router.push({
        path: `${this.platform}_verify`,
        query: { returnUrl: sbaseData.returnUrl },
      });
    },
    togoVerifyNew() {
      if (sbaseData.isSetting) {
        return;
      }
      this.$router.push({
        path: `${this.platform}New_verify`,
        query: { returnUrl: sbaseData.returnUrl, markCode: sbaseData.markCode },
      });
    },
    submit() {
      if (sbaseData.isSetting) {
        return;
      }
      this.formData = this.formData.filter((m) => {
        m.checkFlag = !m.checkFlag; //触发校验
        return true;
      });

      this.$nextTick(() => {
        if (this.formIsValid()) {
          this.isSubmitting = true;
          let submitData = {
            tenantId: this.tenantId,
            sess: this.member.session,
            session: this.member.session,
            customFormId: sbaseData.customFormId,
            linkId: sbaseData.linkId,
            instanceId: this.formInfo.instanceId,
            globalUserId: this.user.globalUserId,
            url: window.location.href,
            referenceUrl: interact.isWeChat ? "微信" : document.referrer,
            preview: sbaseData.preview,
            tc: sbaseData.tc,
            markCode: sbaseData.markCode,
            markType: sbaseData.markType,
            marketingSess: ck.cookie("marketingSess"),
            items: [],
            openId: "",
            subSeminarIds: [], //分会场数据
            signPointItems: [], //签到点数据
            ver: "v2.0.1", // todo 不加接口报错
          };
          if (this.rulesJump == 2) {
            submitData = { rulesJump: this.rulesJump, ...submitData };
          }
          if (this.user.weChatId && this.user.openId) {
            submitData.isBind = true;
            submitData.weChatId = this.user.weChatId;
            submitData.openId = this.user.openId;
          } else if (
            interact.isWeChat &&
            (sbaseData.weChatId || sbaseData.returnUrl)
          ) {
            let weChatId = sbaseData.weChatId;
            if (!weChatId) {
              const url = sbaseData.returnUrl;
              const re = new RegExp(
                "(^|&)" + "weChatId" + "=([^&]*)(&|$)",
                "i"
              );
              const Parameter = url.match(re);
              if (Parameter !== null) {
                weChatId = Parameter[2];
              }
            }

            const wechatInfo = ck.cookie("verifyInfo_" + weChatId);
            if (wechatInfo && wechatInfo.original) {
              submitData.isBind = true;
              submitData.weChatId = weChatId;
              submitData.openId =
                wechatInfo.original.openid || wechatInfo.original.openId;
            }
          }

          if (this.formInfo.enableWxFollow == 1 && !submitData.openId) {
            submitData.openId = window.$sk.template.get()
              ? window.$sk.template.get().user.subscribeOpenId
              : "";
          }
          this.formData.forEach((d) => {
            if (!d.subSeminar && !d.signPoint && d.value && d.isShow) {
              submitData.items.push(d.value);
              if (
                d.value.fieldName === "mobile" &&
                parseInt(d.isSendSms) === 1
              ) {
                submitData.verificationCode = d.value.checkCode;
              }
            }
            // 处理分会场
            if (d.subSeminar && d.result.model) {
              if (!(d.result.model instanceof Array)) {
                //单选分会场
                submitData.subSeminarIds.push(d.result.model.optionId);
              } else {
                d.result.model.forEach((s) => {
                  if (s.checked) {
                    submitData.subSeminarIds.push(s.optionId);
                  }
                });
              }
            }
            // 处理签到点
            if (d.signPoint) {
              this.signPointInfo.forEach((s) => {
                if (d.value.value.indexOf(s.name) > -1) {
                  d.value.value.splice(d.value.value.indexOf(s.name), 1, s.id);
                }
              });
              submitData.signPointItems.push({
                fieldName: d.value.fieldName,
                value: d.value.value,
              });
            }
          });

          //this.beforeRegisterHandler(submitData);

          console.log("submit formData--", submitData, this.formData);
          service.submitCustomform(submitData).subscribe((data) => {
            this.afterRegisterHandler(data);
            setTimeout(() => {
              this.isSubmitting = false;
            }, 500);
          });
        } else {
          this.isSubmitting = false;
        }
      });
    },

    afterRegisterHandler(data) {
      if (data.result != 0) {
        window.$sk.alert(data.desc);
      } else {
        //判断作为报名，是否报名成功
        if (data.content.status === "successfully") {
          //存在签到点字段返回信息
          if (data.content.signpointDesc) {
            window.$sk.alert("报名成功！\r\n" + data.content.signpointDesc);
          }
          this.jumpLink(data.content);
        } else {
          window.$sk.alert("报名失败！\r\n" + data.content.statusDesc);
        }
      }
    },
    jumpLink(data) {
      if (interact.isMobile && this.formInfo.completeActionType == "1") {
        //手机端并且是选的抽奖 跳转抽奖
        const luckyDrawId =
          this.formInfo.completeAction || this.formInfo.luckyDrawId;
        service
          .getLuckydraw({
            luckyDrawId: luckyDrawId,
            tenantId: this.tenantId,
            hasVirtualAward: false,
          })
          .subscribe((d) => {
            if (sbaseData.returnUrl) {
              window.$sk.goto(sbaseData.returnUrl);
            } else {
              window.parent.location.href = d.content.shortUrl.wap.normal;
            }
          });
      } else {
        //let successUrl ='';
        let code = data.qrCode && data.statusCode != 1 ? data.qrCode : "";
        let query = {
          needVerify:
            data.statusCode == 2 || data.statusCode == 3
              ? 0
              : this.formInfo.customFormIsNeedVerify,
          qrCode: code,
          contactId: data.enteredId,
        };
        if (data.statusCode == 4) {
          query.isRefuse = 1;
        }
        if (sbaseData.returnUrl) {
          window.$sk.goto(sbaseData.returnUrl);
        } else if (
          this.formInfo.completeActionType == "2" &&
          this.formInfo.completeAction
        ) {
          // 结束后跳转链接
          window.parent.location.href = this.formInfo.completeAction;
        } else {
          const str =
            window.location.href.toLocaleLowerCase().indexOf("new") > 0
              ? "New"
              : "";
          this.$router.push({
            path: `${this.platform}${str}_success`,
            query: query,
          });
        }
      }
    },
    initWxWorkShare() {
      const url = URLS.removeSearchParam(
        window.location.href,
        "token",
        "retCode",
        "puzzleFlag"
      );
      const info = this.formInfo;
      const shareInfo = {
        title: info.shareTitle || info.title, // 分享标题,
        desc: info.shareDesc || "", // 分享描述,
        link:
          URL.weworkCustomerJumpUrl.replace("{$tenantId}", this.tenantId) +
          encodeURIComponent(url), //这里需要改
        imgUrl: info.shareImageRealPath
          ? "https:" + info.shareImageRealPath
          : "", // 分享图标
      };
      shareInfo.link = window.$swxsdk.urlAddChannel(shareInfo.link);
      window.wx.onMenuShareAppMessage({ ...shareInfo });
      window.wx.onMenuShareWechat({ ...shareInfo });
      window.wx.onMenuShareTimeline({ ...shareInfo });
    },

    initWeChatShare() {
      if (!interact.isWeChat) {
        return;
      }
      const formInfo = this.formInfo;
      const shareInfo = {
        title: formInfo.shareTitle || formInfo.title, // 分享标题,
        desc: formInfo.shareDesc || "", // 分享描述,
        link: sbaseData.weChatId
          ? window.config.weChatOauthUrl +
            "?weChatId=" +
            sbaseData.weChatId +
            "&scope=&return_url=" +
            encodeURIComponent(
              URLS.removeSearchParam(
                window.location.href,
                "token",
                "retCode",
                "puzzleFlag"
              )
            )
          : window.location.href,
        imgUrl: formInfo.shareImageRealPath
          ? "https:" + formInfo.shareImageRealPath
          : "", // 分享图标
      };
      window.$swxsdk.initWxSdk(
        { tenantId: formInfo.tenantId, weChatId: formInfo.attachWXAccount },
        window.apiUrl
      );
      window.$swxsdk.on("sharer", shareInfo);
      window.$swxsdk.on("sharer_friends", shareInfo);
      if (formInfo.enableShare == 0) {
        window.$swxsdk.on("hideAllNonBaseMenuItem");
      } else {
        window.$swxsdk.on("showAllNonBaseMenuItem");
      }
    },

    setTitle(formInfo) {
      if (formInfo.instanceId) {
        service
          .getChannel({
            id: formInfo.instanceId,
          })
          .subscribe((instanceInfo) => {
            document.title = sbaseData.preview
              ? `预览${this.platform}_${formInfo.title}_表单管理_${instanceInfo.content.name}_线下会议_Smarket智营`
              : instanceInfo.content.name;
          });
      } else {
        document.title = sbaseData.preview
          ? `预览${this.platform}_${formInfo.title}_表单管理_Smarket智营`
          : formInfo.title;
      }
    },
  },
};
